import jStat from 'jstat';

import * as base from './base';
import { zScore } from 'simple-statistics';

const makePdFn = (mean, stdev) => x =>
  jStat.normal.pdf(x, mean, stdev);

export const makeInvFn = (mean, stdev) => alpha =>
  jStat.normal.inv(alpha, mean, stdev);

const makeCdfFn = (mean, stdev) => cutoff =>
  jStat.normal.cdf(cutoff, mean, stdev);

const getPds = (mean, stdev) => {
  const xMin = mean - (4 * stdev);
  const xMax = mean + (4 * stdev);

  const pdFn = makePdFn(mean, stdev);
  return base.getPds(xMin, xMax, pdFn);
};

const getPdsForGraphTicks = (mean, stdev) => {
  return base.getPdsForGraphTicks(mean, stdev);
};

const getCutoffsByAlpha = (mean, stdev, alpha) => {
  const pdFn = makePdFn(mean, stdev);
  const invFn = makeInvFn(mean, stdev);

  return base.getCutoffsByAlpha(alpha, pdFn, invFn);
};

const getCutoffsByCutoffXValues = (mean, stdev, leftCutoffX, rightCutoffX) => {
  const pdFn = makePdFn(mean, stdev);

  return base.getCutoffsByCutoffXValues(pdFn, leftCutoffX, rightCutoffX);
};

const getAlphaByCutoffsAndTailType = (mean, stdev, leftCutoffValue, RightCutoffValue, tailType) =>
  base.getAlphaByCutoffsAndTailType(makeCdfFn(mean, stdev), leftCutoffValue, RightCutoffValue, tailType);

const getZScoreByCutoffValue = (mean, stdev, cutoffValue) =>
  zScore(cutoffValue, mean, stdev);

const getCutoffValueByZScore = (mean, stdev, zScoreValue) => (
  (zScoreValue * stdev) + mean
);

const normalDistributionFunctions = {
  getPds: ({ mean, stdev }) => getPds(+mean, +stdev),
  getGraphTicks: ({ mean, stdev }) => getPdsForGraphTicks(+mean, +stdev),
  getCutoffsByAlpha: ({ mean, stdev }, alpha) => (
    getCutoffsByAlpha(+mean, +stdev, +alpha)
  ),

  getCutoffsByCutoffXValues: ({ mean, stdev }, leftCutoffX, rightCutoffX) => (
    getCutoffsByCutoffXValues(+mean, +stdev, +leftCutoffX, +rightCutoffX)
  ),

  getAlphaByCutoffsAndTailType: ({ mean, stdev }, leftCutoffValue, RightCutoffValue, tailType) => (
    getAlphaByCutoffsAndTailType(+mean, +stdev, +leftCutoffValue, +RightCutoffValue, tailType)
  ),

  getZScoreByCutoffValue: ({ mean, stdev }, cutoffValue) => (
    getZScoreByCutoffValue(+mean, +stdev, +cutoffValue)
  ),

  getCutoffValueByZScore: ({ mean, stdev }, zScoreValue) => (
    getCutoffValueByZScore(+mean, +stdev, +zScoreValue)
  )
};

export default normalDistributionFunctions;
